import './styles/fnd-expandable.scss'
export const Expandable = (props: {children: any}) => {
    return (
        <div
        className='fnd-expandable'
        >
            {props.children}
        </div>
      );
}